import { client } from '../../config/apolloClient/client'
import { gql } from '@apollo/client'

const CREATE_DIRECT_UPLOAD_URL_MUTATION = gql`
  mutation CreateDirectUploadUrl($filename: String!) {
    createDirectUploadUrl(filename: $filename) {
      contentType
      filename
      fileUrl
      directUploadUrl
      s3ObjectKey
    }
  }
`

export const uploadToS3 = async (file) => {
  const { data } = await client.mutate({
    mutation: CREATE_DIRECT_UPLOAD_URL_MUTATION,
    variables: { filename: file.name },
    fetchPolicy: 'no-cache'
  })

  const { filename, fileUrl, contentType, directUploadUrl } = data.createDirectUploadUrl || {}
  if (!filename || !contentType) {
    throw new Error('Failed to get upload URL')
  }
  if (file.type !== contentType) {
    throw new Error('File type does not match the expected content type')
  }

  // Upload the file to S3
  await fetch(
    directUploadUrl,
    {
      method: 'PUT',
      headers: {
        'Content-Type': file.type
      },
      body: file
    }
  )

  return fileUrl
}
